import{jsx as e,jsxs as n,Fragment as b}from"react/jsx-runtime";import{useEffect as g}from"react";import{createPortal as y}from"react-dom";import{CSSTransition as v}from"react-transition-group";import o,{css as k,createGlobalStyle as d}from"styled-components";import T from"../../icons/components/CloseIcon.js";import{resetButtonStyle as E}from"../../utils/utils.js";import{FocusTrap as C}from"../FocusTrap.js";const s=k`
  .backgroundTransition-enter {
    opacity: 0;
  }

  .backgroundTransition-enter.backgroundTransition-enter-active {
    opacity: 1;
    transition: opacity 0.25s ease-in-out;
  }

  .backgroundTransition-exit {
    opacity: 1;
  }

  .backgroundTransition-exit.backgroundTransition-exit-active {
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
  }
`,S=o.div`
  ${s}
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 200;
  pointer-events: none;
`,j=o.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`,P=o.div`
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.3);
  pointer-events: auto;
`,z=o.div`
  position: relative;
  overflow-y: auto;

  padding: 1rem;
  background-color: white;
  border-radius: 3px;
  box-shadow:
    0px 24px 38px rgba(0, 0, 0, 0.1),
    0px 9px 46px rgba(0, 0, 0, 0.09),
    0px 11px 15px rgba(0, 0, 0, 0.15);

  margin: 1rem;
  width: 80vw;
  max-width: 512px;
  pointer-events: auto;
`,F=o.button`
  ${E}
  display: flex;
  justify-self: flex-end;

  &:focus-visible {
    outline: revert;
  }

  &:hover {
    cursor: pointer;
  }

  svg {
    font-size: 1.5rem;
  }
`,O=d`
  body {
    overflow: hidden;

    ${typeof window<"u"&&window.innerWidth>1024&&`
        padding-right: 15px !important;
    `}
  }
`,L=d`
  ${s}
`,c=({children:l,isOpen:t,contentStyles:p,withPortal:u=!1,withCloseIcon:m=!0,onClose:i,focusTrapProps:f={},...w})=>{g(()=>{const a=x=>{x.key==="Escape"&&t&&i()};return t&&window.addEventListener("keydown",a),()=>{window.removeEventListener("keydown",a)}},[i,t]);const h=!!(typeof window<"u"&&window.document&&window.document.createElement),r=e(v,{in:t,mountOnEnter:!0,unmountOnExit:!0,timeout:400,classNames:"backgroundTransition",children:n(b,{children:[e(L,{}),n(S,{...w,children:[e(P,{"data-testid":"background",onClick:i}),e(C,{pause:!t,...f,children:e(j,{children:n(z,{style:p,role:"dialog","aria-modal":"true","aria-labelledby":"modal-title",children:[m&&e(F,{onClick:i,"data-testid":"close",type:"button","aria-label":"Close dialog",children:e(T,{})}),l]})})}),e(O,{})]})]})});return u&&h?y(r,document.body):r};export{c as Modal,c as default};
